import ProductFullWithTransluscentDeal from "app/pages/Listing/Product/ProductFullWithTransluscentDeal";

export default props => <ProductFullWithTransluscentDeal {...props} />;
